import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import SubSearchDrawer from "./sub/SubSearchDrawer";


export const DrawerTriger = styled.button`
  cursor: pointer;
  border: 1px solid #d0d0d0;
  line-height: 28px;
  padding: 0 13px;
  text-align: center;
  height: 28px;
  margin-right: 5px;
`;


export const Label = styled.span`
  margin-right: 10px;
  line-height: 28px;
 
`;


/**
 * title: 조건 이름
 * target: 실제 검색의 키
 * setSearchObject: 검색조건 설정 메서드
 * codeIdx: 전체 코드 중에서 현재 드로어 에서 보여줄 코드들의 상위 부모키
 * selected: 선택된 코드
 * listener : 수정시 사용할 리스너
 * path : 상세페이지에 text값
 * returnAsObject : id가 아닌 객체형태로 반환
 * */


/***
 *  Todo
 *  DrawerBasic > SubSearchDrawer > InnerDiv 에서 root 를 쓰는데 과연 그 root가 필요한 값인지 확인해볼 필요가 있다.
 *  자산의 객체 of 객체 에서는  root가 서로 다른 객체를 나타내므로 필요하지만 일반적이 드로어 사용 상황에서는 root가 필요하지 않은 상황
 *
 */


function DrawerBasic({title, data, id, target, codeIdx, returnData, required, listener, path, returnAsObject}) {
    const inputStyle = {
        backgroundColor: required && (!returnData.data || !returnData.data[target] || returnData.data[target] === '' || returnData.data[target] === '0') ? '#ffe5e5' : '',
        border: required && (!returnData.data || !returnData.data[target] ||  returnData.data[target] ==='' || returnData.data[target] === '0') ? '1px solid #e53939' : '',
        outline:'none'
    };
    const [label, setLabel] =useState("선택");
    const [slideIn, setSlideIn] =useState(false);
    const openDrawer =()=>{
        setSlideIn(true);
    }

    useEffect(()=>{
        if(required){
            returnData.fnc(prev => ({
                ...prev,
                required_validate: {...(prev && prev.required_validate ? prev.required_validate : {}), [target] : returnData && returnData.data && returnData.data[target] ? true : false}
            }));
        }
        if(path && label === "선택") setLabel(path)
    }, [path])


    return (
        <>
            <div>
                <DrawerTriger
                    style={required ? inputStyle : {}}
                    onClick={openDrawer}
                    className={`${label === "선택" ? "print-hidden" : ""}`}
                >{label}</DrawerTriger>
            </div>
            {/*)}*/}
            <div className={`drawer-background ${slideIn ? 'show' : 'none'}`} onClick={()=>setSlideIn(false)}></div>
            <SubSearchDrawer
                title={title} data={data} target={target}
                returnData={returnData} id={id}
                slided={{slideIn:slideIn, setSlideIn:setSlideIn}}
                width={30} codeIdx={codeIdx}
                labeled={{label:label, setLabel:setLabel}}
                required={required}
                listener={listener}
                returnAsObject={returnAsObject}
            />
        </>
    );
}

export default DrawerBasic;
